import request from './request';

// 货币列表
export const getExchange = (params) => request.get('/scmp-rest/exchange/list', params);
// 实时汇率
export const getRealTime = (params) => request.get('/scmp-rest/exchange/index', { params });
// 模糊查询
export const getSearExchange = (params) => request.get('/scmp-rest/exchange/fuzzySearch', { params });
// 标题
export const getDetailTitle = (params) => request.get('/scmp-rest/kindDict/detail', { params });
// 一级分类
export const getOneList = (params) => request.post(`/scmp-rest/kindDict/list?kindType=${params.kindType}&parentId=${params.parentId}&xzqhbm=${params.xzqhbm}`);
// 二级分类 /scmp-rest/information/appPage
export const getTwoList = (params) => request.post(`/scmp-rest/information/queryInfoBySecondPage`, params);

// 资讯 详情
export const getInfomation = (params) => request.post(`/scmp-rest/information/detailedInformation?id=${params.id}&userId=${params.userId}`);


// 使馆  /scmp-rest/embassy/type/list
export const getEmbassy = (params) => request.get(`/scmp-rest/embassy/type/list`, { params });
export const getEmbassyDetail = (params) => request.get(`/scmp-rest/embassy/detail/list`, { params });
// export const GetProductDetail = (params) => request.get('/goods/detail', { params }); /scmp-rest/kindDict/list
// export const post = (params) => request.post('/scmp-rest/exchange/list', params); 
// 上传 /scmp-rest/coms/common/file/upload
export const uploadImage = (params) => request.post(`/scmp-rest/coms/common/file/upload`, params);

// 我的反馈 列表/scmp-rest/coms/common/dict/selectList
export const getSelectList = (params) => request.post(`/scmp-rest/coms/common/dict/selectList?dicType=${params.dicType}&dictName=${params.dictName}&isFuzzy=${params.isFuzzy || false}`);

// 反馈问题
export const feedbackRecord = (params) => request.post(`/scmp-rest/feedbackRecord/save`, params);

// 问题反馈记录 /scmp-rest/feedbackRecord/getListByPage

export const getListByPage = (params) => request.post(`/scmp-rest/feedbackRecord/getListByPage`, params);
// 急救包 /scmp-rest/aidPhrase/getAidPhraseList
export const getAidPhraseList = (params) => request.get(`/scmp-rest/aidPhrase/getAidPhraseList`, { params });


// 签证 /scmp-rest/visaExemption/checkExemption
// 是否可以免签
export const getCheckExemption = (params) => request.get(`/scmp-rest/visaExemption/checkExemption`, { params });

// 国籍 /scmp-rest/nationalityInfo/getGroupList

export const getGroupList = (params) => request.get(`/scmp-rest/nationalityInfo/getGroupList`, { params });
// 模糊搜索

export const fuzzySearch = (params) => request.get(`/scmp-rest/nationalityInfo/fuzzySearch`, { params });
// 反馈详情
export const feedDetail = (params) => request.post(`/scmp-rest/feedbackRecord/getById?id=${params.id}`);

// 下载地址
export const getDownloadVersion = (params) => request.post(`/scmp-rest/appVersion/getDownloadVersion?channelId=${params.channelId}`);

// 收藏分享
export const collection = (params) => request.get(`/scmp-rest/information/collection?id=${params.id}&isCollection=${params.isCollection}&userId=${params.userId}`);
// 点赞
export const like = (params) => request.get(`/scmp-rest/information/like?id=${params.id}&isCollection=${params.isCollection}&userId=${params.userId}`);


// 到期提醒
export const visaExpiration = (params) => request.post(`/scmp-rest/visaExpiration/save`, params);
// 根据id 查询 到期时间
export const getByUserIdTime = (params) => request.get(`/scmp-rest/visaExpiration/getByUserId?userId=${params.userId}`,);

// 接口获取英文数据-------------------------------------------

export const getAllElements = (params) => request.get(`/scmp-rest/pageElement/getAllElements`,);

// 获取护照免签列表
export const getPassportList = (params) => request.post(`/scmp-rest/information/queryInformationByVisaRelation`, params);